import React, { useState } from "react";

import StaffNavbar from "../components/AdminSideComponents/layout/staff/StaffNavbar";
import StaffSidebar from "../components/AdminSideComponents/layout/staff/StaffSidebar";
import StaffBottomNav from "../components/AdminSideComponents/layout/staff/StaffBottomNav";

import { BOTTOM_NAV_HEIGHT } from "../utils/constants";

const StaffLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="relative h-screen w-full overflow-hidden">
      <StaffSidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />

      <div className="flex flex-col h-screen lg:ml-[14.5rem]">
        {/* Navbar — desktop only */}
        <div className="fixed top-0 left-0 right-0 lg:ml-[14.5rem] z-20 hidden md:block">
          <StaffNavbar setIsSidebarOpen={setIsSidebarOpen} />
        </div>

        <main
          style={{
            scrollbarGutter: "stable",
            paddingBottom: `${BOTTOM_NAV_HEIGHT}px`,
          }}
          className="flex-1 overflow-y-auto bg-gray-100 md:mt-[3.9rem]"
        >
          {children}
        </main>

        <StaffBottomNav />
      </div>
    </div>
  );
};

export default StaffLayout;
